import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AvailableLanguage } from '../common/types';

declare var _global_configs_: object;


@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  static VERSION = '0.0.1';
  static UPDATE_STATE_INTERVAL = 30000;
  static API_ENDPOINT = environment.baseUrl;
  static API_ENDPOINT_V2 = environment.baseUrlV2
  static REQUEST_TIMEOUT = 120000;
  static ENABLE_DEBUG_LOGS = true;
  static AVAILABLE_LANGUAGES: AvailableLanguage[] = ['fa'];
  constructor() { }

  static async load() {
    // =>update api endpoint
    // console.log(window.location.origin)
    if (window.location.origin) {
      SettingsService.API_ENDPOINT = window.location.origin + '/api';
      // log('updated api endpoint:', SettingsService.API_ENDPOINT);
    }
    // =>update settings variables with global configs
    try {
      if (_global_configs_) {
        for (const key of Object.keys(_global_configs_)) {
          if (SettingsService[key]) {
            SettingsService[key] = _global_configs_[key];
          }
        }
        // log('updated settings with global configs:', _global_configs_);
      }
    } catch (e) { }
  }
}
